export const inputDelay = 700;
export const validateDelay = 500;
